import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import logo from 'assets/images/main_timeline_logo.png';
import * as palette from 'config';

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 1rem 0 0.5rem;
    height: ${palette.HEADER_SIZE};
    background: #f2f2f2;

    & > * {
        margin: 0 0.2rem;
    }

    img {
        max-height: ${palette.HEADER_SIZE};
    }
`;

export const Header: FC<PropsWithChildren> = (props) => {
    return (
        <HeaderContainer {...props}>
            <img src={logo} alt="logo" />
            {props.children}
        </HeaderContainer>
    );
};
